"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The CreateCustomerContactCommand model module.
 * @module model/CreateCustomerContactCommand
 * @version 1.1.3-alpha.1
 */
class CreateCustomerContactCommand {
  /**
   * Constructs a new <code>CreateCustomerContactCommand</code>.
   * @alias module:model/CreateCustomerContactCommand
   * @param email {String} 
   * @param name {String} 
   * @param last_name {String} 
   * @param is_admin {Boolean} 
   * @param is_counted {Boolean} 
   */
  constructor(email, name, last_name, is_admin, is_counted) {
    CreateCustomerContactCommand.initialize(this, email, name, last_name, is_admin, is_counted);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, email, name, last_name, is_admin, is_counted) {
    obj['email'] = email;
    obj['name'] = name;
    obj['last_name'] = last_name;
    obj['is_admin'] = is_admin;
    obj['is_counted'] = is_counted;
  }

  /**
   * Constructs a <code>CreateCustomerContactCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CreateCustomerContactCommand} obj Optional instance to populate.
   * @return {module:model/CreateCustomerContactCommand} The populated <code>CreateCustomerContactCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new CreateCustomerContactCommand();
      if (data.hasOwnProperty('customer_id')) {
        obj['customer_id'] = _ApiClient.default.convertToType(data['customer_id'], 'String');
      }
      if (data.hasOwnProperty('email')) {
        obj['email'] = _ApiClient.default.convertToType(data['email'], 'String');
      }
      if (data.hasOwnProperty('password')) {
        obj['password'] = _ApiClient.default.convertToType(data['password'], 'String');
      }
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('last_name')) {
        obj['last_name'] = _ApiClient.default.convertToType(data['last_name'], 'String');
      }
      if (data.hasOwnProperty('job_title')) {
        obj['job_title'] = _ApiClient.default.convertToType(data['job_title'], 'String');
      }
      if (data.hasOwnProperty('is_admin')) {
        obj['is_admin'] = _ApiClient.default.convertToType(data['is_admin'], 'Boolean');
      }
      if (data.hasOwnProperty('is_suspended')) {
        obj['is_suspended'] = _ApiClient.default.convertToType(data['is_suspended'], 'Boolean');
      }
      if (data.hasOwnProperty('is_counted')) {
        obj['is_counted'] = _ApiClient.default.convertToType(data['is_counted'], 'Boolean');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>CreateCustomerContactCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CreateCustomerContactCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of CreateCustomerContactCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['customer_id'] && !(typeof data['customer_id'] === 'string' || data['customer_id'] instanceof String)) {
      throw new Error("Expected the field `customer_id` to be a primitive type in the JSON string but got " + data['customer_id']);
    }
    // ensure the json data is a string
    if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
      throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
    }
    // ensure the json data is a string
    if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
      throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    // ensure the json data is a string
    if (data['last_name'] && !(typeof data['last_name'] === 'string' || data['last_name'] instanceof String)) {
      throw new Error("Expected the field `last_name` to be a primitive type in the JSON string but got " + data['last_name']);
    }
    // ensure the json data is a string
    if (data['job_title'] && !(typeof data['job_title'] === 'string' || data['job_title'] instanceof String)) {
      throw new Error("Expected the field `job_title` to be a primitive type in the JSON string but got " + data['job_title']);
    }
    return true;
  }
}
CreateCustomerContactCommand.RequiredProperties = ["email", "name", "last_name", "is_admin", "is_counted"];

/**
 * @member {String} customer_id
 */
CreateCustomerContactCommand.prototype['customer_id'] = undefined;

/**
 * @member {String} email
 */
CreateCustomerContactCommand.prototype['email'] = undefined;

/**
 * @member {String} password
 */
CreateCustomerContactCommand.prototype['password'] = undefined;

/**
 * @member {String} name
 */
CreateCustomerContactCommand.prototype['name'] = undefined;

/**
 * @member {String} last_name
 */
CreateCustomerContactCommand.prototype['last_name'] = undefined;

/**
 * @member {String} job_title
 */
CreateCustomerContactCommand.prototype['job_title'] = undefined;

/**
 * @member {Boolean} is_admin
 */
CreateCustomerContactCommand.prototype['is_admin'] = undefined;

/**
 * @member {Boolean} is_suspended
 */
CreateCustomerContactCommand.prototype['is_suspended'] = undefined;

/**
 * @member {Boolean} is_counted
 */
CreateCustomerContactCommand.prototype['is_counted'] = undefined;
var _default = CreateCustomerContactCommand;
exports.default = _default;